export default {
  display: true,
  position: 'bottom',
  fullWidth: false,
  reverse: false
};
